import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconSolidLock = ({ color = 'var(--color-accent-2)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7.5" fill={color} stroke="#8F51CE"/>
            <g>
                <path d="M6.57143 5.53125V6.375H9.42857V5.53125C9.42857 4.7543 8.78929 4.125 8 4.125C7.21071 4.125 6.57143 4.7543 6.57143 5.53125ZM5.42857 6.375V5.53125C5.42857 4.13379 6.58036 3 8 3C9.41964 3 10.5714 4.13379 10.5714 5.53125V6.375H10.8571C11.4875 6.375 12 6.87949 12 7.5V10.875C12 11.4955 11.4875 12 10.8571 12H5.14286C4.5125 12 4 11.4955 4 10.875V7.5C4 6.87949 4.5125 6.375 5.14286 6.375H5.42857Z"
                      fill="white"/>
            </g>
            <defs>
                <clipPath>
                    <rect width="8" height="9" fill="white" transform="translate(4 3)"/>
                </clipPath>
            </defs>
        </svg>

    </div>
);

export default IconSolidLock;
